import React from "react";
import { Text } from "@radix-ui/themes";

export const WHATSAPP_MESSAGING_LIMITS_URL = "https://developers.facebook.com/documentation/business-messaging/whatsapp/messaging-limits#automatic-scaling";

export default function WhatsappMessagingLimitHelp({ size = "1" }) {
  return (
    <Text size={size} color="gray">
      Meta automatically increases WhatsApp messaging tiers when you send high-quality messages across your business
      phone numbers and templates, and your business uses at least half of its current limit in the last 7 days.{" "}
      <Text asChild size={size}>
        <a
          href={WHATSAPP_MESSAGING_LIMITS_URL}
          target="_blank"
          rel="noreferrer"
          style={{ color: "var(--blue-11)", textDecoration: "underline" }}
        >
          Learn how Meta raises limits.
        </a>
      </Text>
    </Text>
  );
}
